module.exports = __webpack_public_path__ + "img/zgkjdaxfsdy.e97db79d.png";